module.exports = __webpack_public_path__ + "static/img/company_introduce_1.351e662d.jpg";